import { getActiveOrgId } from '@/lib/activeOrg';
import { supabase } from '@/lib/supabase';

export type SQLTargets = {
  seo: number;
  google_ads: number;
  cold_email: number;
  pipeline: number;
};

const DEFAULT_SQL_TARGETS: SQLTargets = {
  seo: 20,
  google_ads: 50,
  cold_email: 30,
  pipeline: 40,
};

const ceoxSettingsService = {
  async getSQLTargets(): Promise<SQLTargets> {
    const orgId = getActiveOrgId();
    let query = supabase
      .from('ceox_settings')
      .select('value')
      .eq('key', 'sql_targets');

    if (orgId) query = query.eq('organization_id', orgId);

    const { data, error } = await query.maybeSingle();

    if (error) throw error;
    if (!data) return DEFAULT_SQL_TARGETS;

    return { ...DEFAULT_SQL_TARGETS, ...(data.value as Partial<SQLTargets>) };
  },

  async updateSQLTargets(targets: SQLTargets): Promise<void> {
    const {
      data: { session },
    } = await supabase.auth.getSession();

    const orgId = getActiveOrgId();
    const { error } = await supabase
      .from('ceox_settings')
      .upsert(
        {
          key: 'sql_targets',
          value: targets,
          updated_by: session?.user?.id ?? null,
          updated_at: new Date().toISOString(),
          ...(orgId ? { organization_id: orgId } : {}),
        },
        { onConflict: 'key' }
      );

    if (error) throw error;
  },
};

export default ceoxSettingsService;
